import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GoalService } from '../services/goal.service';
import { IndicatorsService } from '../services/indicators.service';
import { forkJoin, Observable } from 'rxjs';

export const goalsIndicatorsResolver: ResolveFn<Observable<any>> = (route, state) => {
  const goalsService = inject(GoalService);
  const indicatorsService = inject(IndicatorsService);

  const strategyId = +route.queryParams['strategyId'];
  const goalId = +route.queryParams['goalId'];


  return forkJoin({
    "indicators": indicatorsService.ListGoalsIndicators(strategyId, goalId),
    "goal": goalsService.getGoal(strategyId, goalId)
  })
};
